import { z } from 'zod';

export const SurveyQuestionAnswerSchema = z.object({
  surveyQuestionHistoryId: z.string().uuid(),
  answer: z.string(),
});

export const SurveyAnswersSchema = z.object({
  answers: z.array(SurveyQuestionAnswerSchema),
});
